module.exports = __webpack_public_path__ + "1cb4a232fb836ccf6b5aa241af26a524.gif";